import { CFAuthGetRef } from 'auth';
import { locations } from '../../common/redux/action_locations';
import {
  FETCH_TEAMS,
  RECEIVED_TEAMS
} from './constants';

export function fetchTeamsAction() {
  return {
    type: FETCH_TEAMS,
    fetchCall: fetchTeams,
    receivedAction: receivedTeamId,
    data: {
      locations,
    }
  };
}

export function fetchTeams() {
  return CFAuthGetRef({
    url: `${process.env.REACT_APP_COACHING_API_URL}/api/Mappings/TeamLeads/Teams`,
    params: null,
    originURL: process.env.PUBLIC_URL,
    loaderName: 'fetchTeamId'
  });
}

export function receivedTeamId(data) {
  if(data) {
    return {
      type: RECEIVED_TEAMS,
      data,
    }
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case RECEIVED_TEAMS:

      if (state.singleOpportunity) {
        //check to ensure that all teams are accounted for for team leads. This will only happen in existing opportunity view pages.
        const teams = JSON.parse(JSON.stringify(action.data));

        state.singleOpportunity.salesAgent.teamLeadTeams.forEach(team => {
          if (teams.every(teamData => teamData.id !== team.id)) {
            teams.push(team);
          }
        });

        return {
          ...state,
          teams,
        };
      } else {
        return {
          ...state,
          teams: action.data,
        };
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/agent-coaching/redux/fetchTeams.js